import { render } from "./AuthShell.vue?vue&type=template&id=56ef6d73&scoped=true"
import script from "./AuthShell.vue?vue&type=script&lang=js"
export * from "./AuthShell.vue?vue&type=script&lang=js"

import "./AuthShell.vue?vue&type=style&index=0&id=56ef6d73&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56ef6d73"]])

export default __exports__